<template>
  <el-dialog
    :before-close="fechar"
    width="80%"
    :visible.sync="visibility"
    :close-on-click-modal="false"
    :modal-append-to-body="false">
      <span slot="title">
        <font-awesome-icon icon="building" />
        Selecionar Aluguel 
      </span>

      <el-form size="mini" label-position="top">
        <el-row :gutter="20">
          <el-col :md="4" :lg="4">
            <el-form-item label="ID">
              <el-autocomplete
                v-model="aluguelPesquisa.idNaImobiliaria"
                :fetch-suggestions="idInputHandler"
                :debounce="1000"
                clearable
                @clear="limparIdAluguelPesquisaHandler"
                :trigger-on-focus="false"
                :hide-loading="true"
                popper-class="invisible-autocomplete-popper"
                style="width: 100%">
              </el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :md="20" :lg="20">
            <el-form-item label="Locatário">
              <el-autocomplete
                v-model="aluguelPesquisa.locatario.nome"
                :fetch-suggestions="locatarioInputHandler"
                :debounce="1000"
                clearable
                @clear="limparNomeAluguelPesquisaHandler"
                :trigger-on-focus="false"
                :hide-loading="true"
                popper-class="invisible-autocomplete-popper"
                style="width: 100%">
              </el-autocomplete>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-row type="flex" justify="end">
        <h4 style="color: #606266; margin: 0px 15px 5px 0px">{{ this.labelQuantidade }}</h4>
      </el-row>

      <el-table
        :data="alugueis"
        @current-change="selecaoLinhaHandler"
        @row-dblclick="cliqueDuploLinhaHandler"
        highlight-current-row
        stripe
        height="250"
        empty-text="Nenhum Aluguel encontrado">
          <el-table-column
            prop="idNaImobiliaria"
            label="ID"
            sortable
            width="90"
          />
          <el-table-column>
            <template slot-scope="scope">
              <el-row :gutter="20" style="backgroundColor: #FFF1CC">
                <el-col :span="8" style="font-weight: bold">
                  {{ scope.row.dataFim ? scope.row.dataFim : '-' }}
                </el-col>
                <el-col :span="8">
                  {{ scope.row.locatario.nome }}
                </el-col>
                <el-col :span="8">
                  {{ util.formatarValor(scope.row.valor) }}
                </el-col>
              </el-row>
              <el-row>
                {{ formatarLinha1EnderecoImovel(scope.row.imovel) }}
              </el-row>
              <el-row>
                {{ formatarLinha2EnderecoImovel(scope.row.imovel) }}
              </el-row>
            </template>
          </el-table-column>

          <infinite-loading
            :identifier="infiniteLoadingId"
            @infinite="pesquisar"
            slot="append"
            force-use-infinite-wrapper=".el-table__body-wrapper">
              <div slot="no-more" />
              <div slot="no-results" />
          </infinite-loading>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="selecionarAluguelHandler"
          type="success"
          size="small"
          round
          class="btn-box-shadow"
        >
        <i class="el-icon-check" />
          Selecionar
        </el-button>

        <el-button
          @click="fechar"
          type="danger"
          size="small"
          round
          class="btn-box-shadow"
        >
        <i class="el-icon-close" />
          Fechar 
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import Util from "../../../util/funcoes.js";

export default {
  props: {
    visibility: Boolean
  },
  data() {
    return {
      infiniteLoadingId: 0,
      linhaSelecionada: undefined
    }
  },
  watch: {
    'aluguelPesquisa.idNaImobiliaria': function(newValue) {
      if(newValue === "") { this.dispararPesquisa() }
    },
    'aluguelPesquisa.locatario.nome': function(newValue) {
      if(newValue === "") { this.dispararPesquisa() }
    }
  },
  computed: {
    ...mapState('logsAcessoStore', {
      alugueis(state) { return state.listaAlugueis },
      aluguelPesquisa(state) { return state.aluguelPesquisa },
      labelQuantidade(state) { return state.labelQuantidadeAlugueis },
      logPesquisa(state) { return state.logPesquisa }
    }),
    util() { return Util }
  },
  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('logsAcessoStore', [
      'listarAlugueis',
      'limparAlugueisListados',
      'limparAluguelPesquisa'
    ]),
    fechar() {
      this.linhaSelecionada = undefined;
      this.limparAluguelPesquisa();
      this.listarAlugueis(this.aluguelPesquisa).then(() => {});
      this.$emit('close');
    },
    pesquisar($state) {
      if(this.aluguelPesquisa.pagina === 0) { this.showLoading(); }
      this.listarAlugueis(this.aluguelPesquisa)
        .then((resultado) => {
          if(this.aluguelPesquisa.pagina === 0) { this.hideLoading(); }
          if(resultado.lista.length === 100) {
            this.aluguelPesquisa.pagina += 1;
            $state.loaded();
          } else if(resultado.lista.length > 0 && this.aluguelPesquisa.pagina === 0) {
            $state.loaded();
            $state.complete();
          } else {
            $state.complete();
          }
        }).catch(() => {
          if(this.aluguelPesquisa.pagina === 0) { this.hideLoading(); }
          this.$message.error("Não foi possível conectar-se ao servidor");
        });
    },
    dispararPesquisa() {
      this.aluguelPesquisa.pagina = 0;
      this.limparAlugueisListados();
      this.infiniteLoadingId += 1;
    },
    idInputHandler(value) {
      this.aluguelPesquisa.idNaImobiliaria = value;
      this.dispararPesquisa();
    },
    locatarioInputHandler(value) {
      this.aluguelPesquisa.locatario.nome = value;
      this.dispararPesquisa();
    },
    selecaoLinhaHandler(row) {
      this.linhaSelecionada = row;
    },
    selecionarAluguelHandler() {
      if(!this.linhaSelecionada) {
        this.$message.warning("Selecione um Aluguel na tabela");
        return;
      }
      this.logPesquisa.aluguel = this.linhaSelecionada;
      this.fechar();
    },
    cliqueDuploLinhaHandler(row) {
      this.logPesquisa.aluguel = row;
      this.fechar();
    },
    limparIdAluguelPesquisaHandler() {
      this.dispararPesquisa();
    },
    limparNomeAluguelPesquisaHandler() {
      this.dispararPesquisa();
    },

    formatarLinha1EnderecoImovel(imovel) {
      return Util.formatarLinha1EnderecoImovel(imovel);
    },
    formatarLinha2EnderecoImovel(imovel) {
      return Util.formatarLinha2EnderecoImovel(imovel);
    },
  }
}
</script>